module.exports = __webpack_public_path__ + "static/5b4bd9d6-75be-4d76-8292-7f6434b9e997-f915375de706e016be7b7d3fed23cf41.woff";